import { mockDataAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStepDelta, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-tool-progress';
const CONV_ID = 'conv-8';
const MD_BLOCK_ID = 'blk-tp-md';
const TP_BLOCK_ID = 'blk-tp-progress';
const METRIC_BLOCK_ID = 'blk-tp-metric';
const ACTION_BAR_BLOCK_ID = 'blk-tp-action-bar';
const markdownText = 'I analyzed your inspection data across all buildings. Here is what I found and the steps I took:';
// Tool progress steps — streamed one at a time via block_delta
const step1 = {
    step_id: 'step-1',
    label: 'Querying inspection records',
    status: 'complete',
    result_summary: '1,247 records found',
    duration_ms: 2000
};
const step2 = {
    step_id: 'step-2',
    label: 'Aggregating deficiency counts',
    status: 'complete',
    result_summary: '247 deficiencies across 38 buildings',
    duration_ms: 1800
};
const step3 = {
    step_id: 'step-3',
    label: 'Generating summary report',
    status: 'complete',
    result_summary: 'Report ready',
    duration_ms: 1200
};
// Final complete tool_progress block
const toolProgressBlock = {
    type: 'tool_progress',
    block_id: TP_BLOCK_ID,
    block_index: 1,
    agent: mockDataAgent,
    task_label: 'Analyzing inspection data',
    steps: [step1, step2, step3],
    is_complete: true
};
const metricBlock = {
    type: 'metric',
    block_id: METRIC_BLOCK_ID,
    block_index: 2,
    label: 'Total Deficiencies Found',
    value: 247,
    trend: 'down',
    context: '12% decrease compared to last quarter'
};
// Action bar — will be merged into the metric block's footerActions
const actionBarBlock = {
    type: 'action_bar',
    block_id: ACTION_BAR_BLOCK_ID,
    block_index: 3,
    actions: [
        {
            id: 'export-csv',
            label: 'Export CSV',
            action: 'export',
            icon: 'fa-light fa-file-csv',
            variant: 'secondary'
        },
        {
            id: 'view-details',
            label: 'View Details',
            action: 'navigate',
            icon: 'fa-light fa-arrow-up-right-from-square',
            variant: 'primary',
            params: { url: '/reports/deficiencies' }
        }
    ],
    layout: 'inline'
};
// Suggested actions — sent via stream_end
const suggestedActions = [
    { label: 'Show me the worst buildings', action: 'query', icon: 'fa-light fa-building', params: {} },
    { label: 'Compare with last year', action: 'query', icon: 'fa-light fa-chart-line', params: {} },
    { label: 'Export full report', action: 'export', icon: 'fa-light fa-download', params: {} }
];
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockDataAgent),
    // 1. Stream markdown intro
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText, 18, 60),
    makeBlockEnd(MD_BLOCK_ID),
    // 2. Tool progress: block_start, then step deltas, then block_complete
    makeBlockStart(TP_BLOCK_ID, 1, 'tool_progress'),
    makeStepDelta(TP_BLOCK_ID, Object.assign(Object.assign({}, step1), { status: 'running' }), 400),
    makeStepDelta(TP_BLOCK_ID, step1, 800),
    makeStepDelta(TP_BLOCK_ID, Object.assign(Object.assign({}, step2), { status: 'running' }), 300),
    makeStepDelta(TP_BLOCK_ID, step2, 700),
    makeStepDelta(TP_BLOCK_ID, Object.assign(Object.assign({}, step3), { status: 'running' }), 300),
    makeStepDelta(TP_BLOCK_ID, step3, 600),
    makeBlockComplete(toolProgressBlock, 200),
    // 3. Metric block
    makeBlockComplete(metricBlock, 400),
    // 4. Action bar — merges into metric block's footerActions
    makeBlockComplete(actionBarBlock, 200),
    // 5. Stream end with suggested actions
    {
        type: 'stream_end',
        payload: {
            response_id: RESPONSE_ID,
            total_blocks: 4,
            cost: {
                model_used: 'gpt-4o',
                input_tokens: 320,
                output_tokens: 180,
                estimated_cost_usd: 0.005,
                tool_calls_count: 3
            },
            duration_ms: 5200,
            agent: mockDataAgent,
            feedback_id: `fb-${RESPONSE_ID}`,
            suggested_actions: suggestedActions
        },
        delayMs: 300
    }
];
export const scenario = {
    name: 'Data Assistant — Tool Progress with Actions',
    description: 'Exercises ToolProgress live streaming (Phase F), action_bar merging into preceding block (Phase H.1), ' +
        'and suggested_actions chips after stream ends (Phase H.2).',
    conversations: mockConversations,
    userMessage: 'Analyze all deficiency trends across my buildings',
    agentIdentity: mockDataAgent,
    sseSequence
};
